import Decimal from "decimal.js-light";
import * as t from "io-ts";
const decimal = new t.Type("decimal", (u) => u instanceof Decimal, (i, ctx) => {
    if (typeof i !== "string" && typeof i !== "number")
        return t.failure(i, ctx, "Wrong type: " + typeof i);
    try {
        return t.success(new Decimal(i));
    }
    catch {
        return t.failure(i, ctx, "Parsing decimal failed: " + i);
    }
}, (v) => v.toString());
export default decimal;
//# sourceMappingURL=decimal.js.map